import { css } from "@microsoft/fast-element";
import { borderRadiusMedium, colorNeutralBackground1, colorTransparentStroke, shadow16, display, spacingHorizontalXXXL, spacingHorizontalXS, spacingHorizontalXXS } from "@fluentui/web-components";
/** MenuList styles
 * @public
 */
export const styles = css `
  ${display("flex")}

  :host {
    flex-direction: column;
    height: fit-content;
    min-width: calc(${spacingHorizontalXXXL} * 5);
    width: auto;
    background-color: ${colorNeutralBackground1};
    border: 1px solid ${colorTransparentStroke};
    border-radius: ${borderRadiusMedium};
    box-shadow: ${shadow16};
    padding: ${spacingHorizontalXS};
    row-gap: ${spacingHorizontalXXS};
  }
`;
//# sourceMappingURL=menu-list.styles.js.map